import { memo } from 'react';

import { NativePushNotificationHandler } from '@/features/notifications/components/nativePushNotificationHandler';
import { NotificationPermissionInit } from '@/features/notifications/components/notificationPermissionInit';
import { WebPushNotificationHandler } from '@/features/notifications/components/webPushNotificationHandler';

/**
 * Unified notification handlers component that initializes:
 * - Native push notification click listeners (iOS/Android via Capacitor)
 * - Web push notification click listeners (via service worker postMessage)
 * - Notification permission state initialization and tracking
 *
 * Mount this component once at the app root level.
 * Uses composition for render isolation - each handler re-renders independently.
 */
export const NotificationHandlers = memo(function NotificationHandlers() {
  return (
    <>
      <NotificationPermissionInit />
      <NativePushNotificationHandler />
      <WebPushNotificationHandler />
    </>
  );
});
